import TemplateCreateDocumentInvoice from './TemplateCreateDocumentInvoice'

export default TemplateCreateDocumentInvoice
